var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"Rj97-PGO_Aexaz3UE2GCk"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a user loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  // Set environment to differentiate between dev/qa/uat/production
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,

  // Define how likely traces are sampled.
  tracesSampleRate: 0.1,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  beforeSend(event, hint) {
    const error = hint?.originalException

    // Suppress ProgressEvent errors from third-party XHR failures (e.g. Klaviyo).
    // Klaviyo's SDK wraps XHR calls in Promises without .catch() handlers.
    // When those XHRs fail (CORS, ad-blocker, network), the browser emits an
    // unhandled promise rejection with a ProgressEvent object. These are not
    // actionable — we don't control Klaviyo's SDK code.
    if (
      error instanceof ProgressEvent ||
      (error &&
        typeof error === 'object' &&
        'type' in error &&
        (error as any).type === 'error' &&
        (error as any).constructor?.name === 'ProgressEvent')
    ) {
      return null
    }

    return event
  },

  // Ignore common third-party script errors that are not actionable.
  denyUrls: [
    // Klaviyo onsite SDK
    /static\.klaviyo\.com/i,
    /a\.klaviyo\.com/i,
    // Facebook Android WebView internal scripts (iabjs_unified_bridge noise).
    // These app:// URLs are injected by the Facebook in-app browser and are never
    // part of our application code — any error originating here is not actionable.
    /iabjs_bridge_init/i,
    /autofill_test_android/i
  ]
})
